import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import {OwnedGiftDto} from "@/store/gift/types";
import {Link} from "@/scenes.ui/link";
import {NewGiftPanel} from "@/scenes.ui/new-gift-panel";
import {ConfirmationPanel} from "@/scenes.ui/confirmation-panel";
import {Tr, TrSpace} from "@/i18n/i18n";
import {GiftUtils} from "@/utils/gift-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class GiftInfoPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement) {
        super(scene, canvas, Tr('gft'));
        this.scene = scene;
    }

    public init(g: OwnedGiftDto, ownProfile: boolean, profileCallback: (playerId: number) => unknown,
                deleteCallback: (giftId: number) => unknown, hideCallback: (giftId: number) => unknown) {
        let light = SpriteUtils.addSprite(this.scene, 0, -140, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT);
        let icon = SpriteUtils.addSprite(this.scene, 0, -140, GiftUtils.getAtlas(g.giftId), g.giftId);

        let self = this;
        let sender = new Link(this.scene, 10 * CU.S, -85 * CU.S, g.presenterName, () => {
            self.close();
            profileCallback(g.presenterId)
        }, '#70ff6a', 16, 0.5);

        let from = TextUtils.addTextAdvanced(this.scene, TrSpace('from2'), sender.getBounds().left / CU.S - 4, sender.y / CU.S + 1,
            '#c6c6c6', 14, 'normal', 420, 'center', 2, Fonts.ARIAL_MT).setOrigin(1, 0.5);

        let blockFirst = TextUtils.addTextAdvanced(this.scene, GiftInfoPanel.getGiftText(g), 0, -5,
            '#f6f6f6', NewGiftPanel.getFontSize(g.text.length), 'normal', 420, 'center', 2, Fonts.ARIAL_MT);

        this.add([light, icon, sender, from, blockFirst]);

        if (ownProfile) {
            SpriteUtils.scale(this.addCustomButton(-125, 150, Tr('delete'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_DECLINE_CROSS, () => {
                let cp = new ConfirmationPanel(self.scene, self.canvas, () => {
                    deleteCallback(g.id);
                }, Tr('podtverzhdenie'), Tr('g.d.conf'), Keys.UI_DECLINE_CROSS, Tr('da'), Tr('net'), undefined);
                cp.openAnimated();
            }), 0.8 / CU.S);

            SpriteUtils.scale(this.addCustomButton(0, 150, g.textHidden ? Tr('show.txt') : Tr('hide.txt'),
                Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_DECLINE_CROSS, () => {
                g.textHidden = !g.textHidden;
                blockFirst.setText(GiftInfoPanel.getGiftText(g));
                hideCallback(g.id);
            }, true), 0.8 / CU.S);

            SpriteUtils.scale(this.addCustomButton(125, 150, Tr('otlichno').toUpperCase(), Keys.UI_ART_GREEN_BUTTON,
                Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => {}), 0.8 / CU.S);

        } else {
            this.addCustomButton(0, 135, Tr('otlichno').toUpperCase(), Keys.UI_ART_GREEN_BUTTON,
                Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => {});
        }
    }

    private static getGiftText(g: OwnedGiftDto) {
        if (!g.text) {
            return Tr('n.txt');
        }
        if (g.textHidden) {
            return Tr('txt.hid');
        }
        return g.text;
    }

    protected onClose(): void {

    }

}
